import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeleteAccountVerifyComponent } from './delete-account-verify.component';
import { NgxOtpInputModule } from 'ngx-otp-input';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [DeleteAccountVerifyComponent],
  imports: [CommonModule, NgxOtpInputModule, TranslateModule],
  exports: [DeleteAccountVerifyComponent],
  providers: [LocalizationService, TranslateModule],
})
export class DeleteAccountVerifyModule {}
